import get from 'lodash/get';
import upperFirst from 'lodash/upperFirst'
import dayjs from "dayjs";
import { host } from '../shared/config';


const ldArticle = (data, state) => {
  const imageUrl = (get(data, 'data.attributes.Media.data.attributes.url') || get(state.website, 'Header.Logo.data.attributes.url'));

  return {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    'headline': get(data, 'data.attributes.Title'),
    'image': [`${host}${imageUrl}`],
    'datePublished': get(data, 'data.attributes.publishedAt'),
    'dateModified': get(data, 'data.attributes.updatedAt'),
    'author': [
      {
        '@type': 'Organization',
        'name': get(state.website, 'Brand') || 'Syn-Pro',
        'url': self.origin,
        'image': `${host}${get(state.website, 'Header.Logo.data.attributes.url')}`,
      },
    ],
  };
};

const ldProduct = (data, state) => {
  const imageUrl = get(data, 'data.attributes.Content[0].Media.data.attributes.url') || get(state.website, 'Header.Logo.data.attributes.url');
  return {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    'name': get(data, 'data.attributes.Name'),
    'image': [`${host}${imageUrl}`],
    'description': get(data, 'data.attributes.Description'),
    'brand': {
      '@type': 'Brand',
      'name': get(state.website, 'Brand'),
    },
  };
};

const ldShopProduct = (data, state) => {
  const imageUrl =
    get(data, "data.attributes.Content[0].Media.data.attributes.url") ||
    get(state.website, "Header.Logo.data.attributes.url");
  return {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: `${get(data, "data.attributes.Title")} - ${get(
      data,
      "data.attributes.PartNumber"
    )}`,
    image: [`${host}${imageUrl}`],
    description: get(data, "data.attributes.Description"),
    brand: {
      "@type": "Brand",
      name: get(data, "data.attributes.brands.data[0].attributes.Title"),
    },
    // Get Brand
    offers: {
      "@type": "Offer",
      areaServed: [
        {
          "@type": "Country",
          name: "United Kingdom",
          "@id": "https://en.wikipedia.org/wiki/United_Kingdom",
        },
      ],
      priceValidUntil: dayjs().add(1, "year").toISOString(),
      availability:
        get(data, "data.attributes.Availability") == "In Stock"
          ? "https://schema.org/InStock"
          : "https://schema.org/MadeToOrder",
      price: get(data, "data.attributes.Price"),
      priceCurrency: "GBP",
    },
    sku: get(data, "data.attributes.PartNumber"),
    url: document.URL,
  };
};

const ldBreadcrumb = (prefix, seo) => {
  
  const {origin, href}  = window.location;
  const itemListElement = []
  const title = (get(seo,'Title') || '').split('|')[0]

  // do position 1
  itemListElement.push({
    "@type": "ListItem",
    position: 1,
    name: upperFirst(prefix || title || ''),
    item: prefix ? `${origin}/${prefix}`: href,
  })

  // do position 2
  if(prefix)
    itemListElement.push({
      "@type": "ListItem",
      position: 2,
      name: upperFirst(title || ''),
      item: href,
    })

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement
  };
};


// const getEvent = () => {
//   return {
//     '@context': 'https://schema.org',
//     '@type': 'Event',
//     'name': 'The Adventures of Kira and Morrison',
//     'startDate': '2025-07-21T19:00-05:00',
//     'endDate': '2025-07-21T23:00-05:00',
//     'eventAttendanceMode': 'https://schema.org/OfflineEventAttendanceMode',
//     'eventStatus': 'https://schema.org/EventScheduled',
//     'location': {
//       '@type': 'Place',
//       'name': 'Snickerpark Stadium',
//       'address': {
//         '@type': 'PostalAddress',
//         'streetAddress': '100 West Snickerpark Dr',
//         'addressLocality': 'Snickertown',
//         'postalCode': '19019',
//         'addressRegion': 'PA',
//         'addressCountry': 'US',
//       },
//     },
//     'image': ['https://example.com/photos/1x1/photo.jpg', 'https://example.com/photos/4x3/photo.jpg', 'https://example.com/photos/16x9/photo.jpg'],
//     'description': "The Adventures of Kira and Morrison is coming to Snickertown in a can't miss performance.",
//     'offers': {
//       '@type': 'Offer',
//       'url': 'https://www.example.com/event_offer/12345_201803180430',
//       'price': '30',
//       'priceCurrency': 'USD',
//       'availability': 'https://schema.org/InStock',
//       'validFrom': '2024-05-21T12:00',
//     },
//     'performer': {
//       '@type': 'PerformingGroup',
//       'name': 'Kira and Morrison',
//     },
//     'organizer': {
//       '@type': 'Organization',
//       'name': 'Kira and Morrison Music',
//       'url': 'https://kiraandmorrisonmusic.com',
//     },
//   };
// };

// const getLogo = () => {
//   return {
//     '@context': 'https://schema.org',
//     '@type': 'Organization',
//     'url': 'http://www.example.com',
//     'logo': 'http://www.example.com/images/logo.png',
//   };
// };

export { ldArticle, ldProduct, ldBreadcrumb, ldShopProduct };
